import React from "react";
import styled, { keyframes } from "styled-components";

// Skeleton koji prati novi layout stranice proizvoda:
// levo 3:4 slika + thumbovi, desno label / naslov / cena / boja / veličine / CTA.
const SkeletonProductPage = () => {
  return (
    <Wrapper>
      <Left>
        <MainImage>
          <Sheen />
        </MainImage>
        <ThumbRow>
          {[...Array(4)].map((_, i) => (
            <Thumb key={i} />
          ))}
        </ThumbRow>
      </Left>

      <Right>
        <Line $w="14rem" $h="1.2rem" />
        <Line $w="70%" $h="3.6rem" style={{ marginTop: "0.6rem" }} />
        <Line $w="26%" $h="2.4rem" style={{ marginTop: "1rem" }} />

        <Row style={{ marginTop: "2.4rem" }}>
          <Dot />
          <Line $w="9rem" $h="1.3rem" />
        </Row>

        <Row style={{ marginTop: "2rem" }}>
          {[...Array(4)].map((_, i) => (
            <Chip key={i} />
          ))}
        </Row>

        <Row style={{ marginTop: "2.8rem" }}>
          <Line $w="11rem" $h="4.6rem" $r="0.4rem" />
          <Line $w="22rem" $h="4.6rem" $r="0.4rem" />
        </Row>

        <div style={{ marginTop: "3rem" }}>
          <Line $w="100%" $h="1.3rem" />
          <Line $w="92%" $h="1.3rem" style={{ marginTop: "1rem" }} />
          <Line $w="76%" $h="1.3rem" style={{ marginTop: "1rem" }} />
        </div>
      </Right>
    </Wrapper>
  );
};

export default SkeletonProductPage;

const sweep = keyframes`
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
`;

const pulse = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.45; }
`;

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 5rem;
  width: 100%;
  max-width: 120rem;
  margin: 0 auto;
`;

const Left = styled.div`
  flex: 0 1 44rem;
  max-width: 44rem;
  min-width: min(100%, 30rem);
`;

const MainImage = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 3 / 4;
  background: var(--bg2, #17171c);
  border: 1px solid var(--line, rgba(255, 255, 255, 0.07));
  border-radius: 0.6rem;
  overflow: hidden;
`;

const Sheen = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(
    100deg,
    transparent 30%,
    rgba(255, 255, 255, 0.045) 50%,
    transparent 70%
  );
  animation: ${sweep} 1.6s infinite;
`;

const ThumbRow = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 1.2rem;
`;

const Thumb = styled.div`
  width: 7.2rem;
  aspect-ratio: 3 / 4;
  background: var(--bg2, #17171c);
  border: 1px solid var(--line, rgba(255, 255, 255, 0.07));
  border-radius: 0.4rem;
  animation: ${pulse} 1.6s ease-in-out infinite;
`;

const Right = styled.div`
  flex: 1;
  min-width: min(100%, 32rem);
  display: flex;
  flex-direction: column;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 1.2rem;
  flex-wrap: wrap;
`;

const Line = styled.div`
  width: ${({ $w }) => $w || "100%"};
  height: ${({ $h }) => $h || "1.4rem"};
  border-radius: ${({ $r }) => $r || "0.3rem"};
  background: rgba(255, 255, 255, 0.07);
  animation: ${pulse} 1.6s ease-in-out infinite;
`;

const Dot = styled.div`
  width: 2.6rem;
  height: 2.6rem;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.07);
  animation: ${pulse} 1.6s ease-in-out infinite;
`;

const Chip = styled.div`
  width: 5.4rem;
  height: 3.6rem;
  border-radius: 0.3rem;
  background: transparent;
  border: 1px solid var(--line2, rgba(255, 255, 255, 0.14));
  animation: ${pulse} 1.6s ease-in-out infinite;
`;
